<template>
  <v-container 
  fluid 
  tag="section">
    <base-material-card 
    icon="mdi-clipboard-text"
    title="Visitas"
    class="px-5 py-3" >
      <v-row dense>
        <v-col cols="12" sm="6" md="4">
          <v-menu
            v-model="isStartDateVisible"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="formattedStartDate"
                label="Fecha desde"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                outlined
              />
            </template>
            <v-date-picker 
              width="380"
              v-model="visitFilters.startDatePicked" 
              locale="es"
              @change="onFilterChange" />
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-menu
            v-model="isEndDateVisible"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="formattedEndDate"
                label="Fecha hasta"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                outlined
              />
            </template>
            <v-date-picker 
              width="380"
              v-model="visitFilters.endDatePicked"
              locale="es" 
              @change="onFilterChange" />
          </v-menu>
        </v-col>
        
        <v-col cols="12" sm="6" md="4">
          <v-select
            v-model="visitFilters.asesor"
            :items="asesores"
            label="Asesor"
            clearable
            @input="onFilterChange"
            outlined
          />
        </v-col>

        <v-col cols="12" sm="6" md="4">
          <v-select
            v-model="visitFilters.region"
            :items="regionName"
            label="Región"
            clearable
            @input="onFilterChange"
            outlined
          />
        </v-col>

        <v-col cols="12" sm="6" md="4">
          <v-select
            v-model="visitFilters.provincia"
            :items="provincias"
            label="Provincia"
            clearable
            @input="onFilterChange"
            outlined
          />
        </v-col>

        <v-col cols="12" sm="6" md="4">
          <v-select
            v-model="visitFilters.estadoNegociacion"
            :items="$store.state.estadoNegociacion"
            label="Estado de Negociación"
            clearable
            @input="onFilterChange"
            outlined
          />
        </v-col>
      </v-row>
      <v-data-table
        :headers="visitTableHeaders"
        :items="filteredProjectVisits"
        :search="searchVisitQuery"
        class="elevation-1 mt-4"
        :loading="isVisitsTableLoading"
        :items-per-page="10"
      >
        <template v-slot:top>
          <v-text-field
            v-model="searchVisitQuery"
            label="Buscar palabra en tabla de reportes ..."
            class="mx-4"
            append-icon="mdi-magnify"
            outlined
          />
        </template>

        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click="currentProjectDetails(item)">
                mdi-eye
              </v-icon>
            </template>
            <span>Ver detalles</span>
          </v-tooltip>
        </template>
      </v-data-table>

      <v-dialog v-model="isVisitDetailsDialogVisible" max-width="600px">
        <v-card>
          <v-card-title>Detalles del Proyecto</v-card-title>
          <v-card-text v-if="selectedProjectData">
            <div v-for="(item, index) in visibleProjectFields" :key="index">
              <strong>{{ item.label }}:</strong> {{ item.value }}
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="primary" text @click="isVisitDetailsDialogVisible = false">
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </base-material-card>
  </v-container>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/firestore'
export default {
  name: 'ReporteVisitas',
  data() {
    return {
      searchVisitQuery: '',
      isVisitsTableLoading: false,
      isVisitDetailsDialogVisible: false,
      isStartDateVisible: false,
      isEndDateVisible: false,
      selectedProjectData: null,
      fieldLabels: {
        codigo: 'Código del Proyecto',
        nombre: 'Nombre del Proyecto',
        direccion: 'Dirección',
        region: 'Región',
        provincia: 'Provincia',
        categoria: 'Categoría del Proyecto',
        tipo: 'Tipo de Proyecto',
        etapa: 'Etapa',
        constructora: 'Constructora',
        inmobiliaria: 'Inmobiliaria',
        proveedorActual: 'Proveedor Actual',
        numeroPisos: 'Cantidad de Pisos',
        numeroDepartamentos: 'Cantidad de Departamentos',
        cantidadPuertas: 'Cantidad de Puertas',
        cantidadCortafuego: 'Cantidad de Cortafuegos',
        asesor: 'Asesor',
        prospector: 'Prospector',
        quienProspecto: 'Prospectado por',
        propectadoAt: 'Fecha de Prospección',
        entrega: 'Fecha de Entrega',
        contactoNegociacion: 'Contacto',
      },
      visitFilters: {
        startDatePicked: "",
        endDatePicked: "",
        asesor: '',
        region: '',
        provincia: '',
        estadoNegociacion: '',
      },
      asesores:[],
      regiones: [],
      provincias: [],
      visitas: [],
      visitTableHeaders: [
        { text: 'Nombre del Proyecto', value: 'nombreProyecto' },
        { text: 'Asunto', value: 'asunto' },
        { text: '¿Presentación Eficaz?', value: 'eficaz' },
        { text: 'Comentario', value: 'comentario' },
        { text: 'Región', value: 'region' },
        { text: 'Provincia', value: 'provincia' },
        { text: 'Inmobiliaria', value: 'inmobiliaria' },
        { text: 'Constructora', value: 'constructora' },
        { text: 'Estado Negociación', value: 'estadoNegociacion' },
        { text: 'Entrega', value: 'entrega' },
        { text: 'Asesor', value: 'asesor' },
        { text: 'Etapa', value: 'etapa' },
        { text: 'Fecha de Visita', value: 'dayMonthYearVisita' },
        { text: 'Hora de Visita', value: 'hourVisit' },
        { text: 'Acciones', value: 'actions', sortable: false },
      ],
    };
  },
  computed: {
    filteredProjectVisits() {
      return this.visitas.filter((visitFilter) => {
        const date = new Date(visitFilter.visitDate);
        const startDatePicked = this.visitFilters.startDatePicked
          ? new Date(this.visitFilters.startDatePicked)
          : null;
        const endDatePicked = this.visitFilters.endDatePicked
          ? new Date(this.visitFilters.endDatePicked)
          : null;
        /* console.log({ date, startDatePicked, endDatePicked }) */
        const dateFilter =
          (!startDatePicked || (date >= startDatePicked)) &&
          (!endDatePicked || (date <= endDatePicked));

        const asesorFilter = this.visitFilters.asesor
          ? (visitFilter.asesor || "").toLowerCase().includes(this.visitFilters.asesor.toLowerCase())
          : true;
        const regionFilter = this.visitFilters.region
          ? (visitFilter.region || "").toLowerCase().includes(this.visitFilters.region.toLowerCase())
          : true;
        const provinciaFilter = this.visitFilters.provincia
          ? (visitFilter.provincia || "").toLowerCase().includes(this.visitFilters.provincia.toLowerCase())
          : true;
        const estadoNegociacionFilter = this.visitFilters.estadoNegociacion
          ? (visitFilter.estadoNegociacion || "").toLowerCase().includes(this.visitFilters.estadoNegociacion.toLowerCase())
          : true;

        /* console.log({ dateFilter, asesorFilter, regionFilter, provinciaFilter, estadoNegociacionFilter }); */
        return dateFilter && asesorFilter && regionFilter && provinciaFilter && estadoNegociacionFilter;
      });
    },
    formattedStartDate() {
      return this.visitFilters.startDatePicked
        ? new Date(this.visitFilters.startDatePicked).toLocaleDateString('es-PE', { timeZone: 'UTC' })
        : '';
    },
    formattedEndDate() {
      return this.visitFilters.endDatePicked
        ? new Date(this.visitFilters.endDatePicked).toLocaleDateString('es-PE', { timeZone: 'UTC' })
        : '';
    },
    visibleProjectFields() {
      if (!this.selectedProjectData) return []
      return Object.keys(this.fieldLabels)
        .filter(key => this.selectedProjectData[key] && this.fieldLabels[key])
        .map(key => ({
          label: this.fieldLabels[key],
          value: this.selectedProjectData[key]
        }));
    },
    regionName() {
      return this.regiones.map(r => r.NOMBRE)
    },
  },
  mounted() {
    this.getVisits();
    this.getRegiones();
    this.searchProvinces();
    this.getAsesores();
  },
  watch: {
    'visitFilters.region'() {
      this.searchProvinces()
      this.visitFilters.provincia = '';
    }
  },
  methods: {
    onFilterChange() {
      this.visitFilters = { ...this.visitFilters };
    },
    async getVisits() {
      this.isVisitsTableLoading = true;
      this.visitas = [];
      const excludedProjectFields = [
        'id', 'cotizacion', 'copiaCorreo', 'foto', 'estadoNegociacion',
        'montoCortafuego', 'comentarios', 'visitas', 'dateFechaFacturacion',
        'razonPerdido', 'estado', 'fechaCreacion', 'fase', 'ipv', 'tipoSistema',
        'dateFechaCotizacion', 'quienGano', 'tipoCliente', 'medioContacto',
        'tipoVivienda', 'reunion', 'quienGano', 'montoPuertas', 'tipoCliente',
        'fechaEdicion', 'montoCerraduras', 'posibilidadCierre', 'planos',
        'comments', 'longitud', 'latitud', 'cantidadDuctos', 'metrados'
      ];

      function parseDateFromDDMMYYYY_HHMMSS(dateStr) {
        const [datePart, timePart] = dateStr.split(' ');
        let [day, month, year] = datePart.split('/');
        day = day.padStart(2, '0');
        month = month.padStart(2, '0');
        year = year.length === 2 ? '20' + year : year;
        const time = timePart || '00:00:00';
        return new Date(`${year}-${month}-${day}T${time}`);
      }
      try {
        const firestoreDB = firebase.firestore();
        const projectsSnapshot = await firestoreDB.collection("proyectos").get();
        projectsSnapshot.forEach((projectDoc) => {
          const projectData = projectDoc.data();
          const projectVisits = projectData.visitas || {};
          const filteredProjectFields = Object.fromEntries(
            Object.entries(projectData).filter(([key]) => !excludedProjectFields.includes(key))
          );
          Object.values(projectVisits).forEach((visita) => {
            const rawVisitDate = visita.fecha_creacion;
            let visitDate = null;
            if (rawVisitDate && typeof rawVisitDate.toDate === 'function') {
              visitDate = rawVisitDate.toDate();
            } else if (typeof rawVisitDate === 'string') {
              visitDate = parseDateFromDDMMYYYY_HHMMSS(rawVisitDate);
            }
            if (!visitDate || isNaN(visitDate.getTime())) return;
            this.visitas.push({
              nombreProyecto: projectData.nombre || '',
              region: projectData.region || '',
              provincia: projectData.provincia || '',
              inmobiliaria: projectData.inmobiliaria || '',
              constructora: projectData.constructora || '',
              estadoNegociacion: projectData.estadoNegociacion || '',
              entrega: projectData.entrega || '',
              asesor: projectData.asesor || '',
              etapa: projectData.etapa || '',
              visitDate,
              hourVisit: visitDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
              dayMonthYearVisita: visitDate.toLocaleDateString("es-PE", { day: '2-digit', month: '2-digit', year: 'numeric' }),
              asunto: visita.asunto || '',
              comentario: visita.comentario || '',
              eficaz: visita.eficaz || '',
              projectData: filteredProjectFields
            });
          });
        });
      } catch (error) {
        console.error('Error al cargar visitas:', error);
      } finally {
        this.isVisitsTableLoading = false;
      }
    },
    currentProjectDetails(item) {
      this.selectedProjectData = item.projectData || {};
      this.isVisitDetailsDialogVisible = true;
    },
    getRegiones() {
      this.regiones = this.$store.state.regiones
    },
    searchProvinces() {
      const region = this.$store.state.regiones.find(r => r.NOMBRE === this.visitFilters.region)
      this.provincias = region ? region.PROVINCIAS : []
    },
    getAsesores() {
      const filteredAdvisors = []
      firebase.firestore().collection('perfiles').get().then((asesoresSnapshot) => {
        asesoresSnapshot.forEach((asesor) => {
          const data = asesor.data()
          if (
            data &&
            data.Proyectos &&
            data.Proyectos.Negociación === true
          ) {
            filteredAdvisors.push(asesor.id)
          }
        })
        /* console.log("perfiles filtrados: ",filteredAdvisors) */

        firebase.firestore().collection('users').get().then((usersSnapshot) => {
          usersSnapshot.forEach((user) => {
            const userData = user.data()
            if (filteredAdvisors.includes(userData.perfil)) {
              this.asesores.push(userData.email)
              /* console.log("usuarios filtrados:" ,userData.email) */
            }
          })
        })
      })
    },
  },
};
</script>
